import './_shared/types/global.types';
import 'moment/locale/de';
import { createApp } from 'vue';
import { createStore } from 'vuex';
import Store from '../store/front';
import Signup from '../apps/Signup/plugin';
import AppMessages from './_shared/plugins/message.plugin';
import { initLogger } from './_shared/hooks/useLogger';
import Slider from './Front/components/Slider.vue';
import Benefits from './Front/components/Benefits.vue';
import MapView from './Front/components/MapView.vue';
import MapPlace from './Front/components/MapPlace.vue';
import ReviewList from './Front/components/ReviewList.vue';
import SmallNavigation from './Front/components/SmallNavigation.vue';
import ThemeSwitcher from './_shared/components/ThemeSwitcher.vue';
import OnlineCourses from './Front/components/OnlineCourses.vue';
import CourseOverview from './Front/components/CourseOverview.vue';
import ContactBar from './_shared/components/ContactBar.vue';
import NewsletterAndContactButton from './_shared/components/buttons/NewsletterAndContactButton.vue';
import { Stage } from './_shared/enums/app-config';

globalThis.__VUE_PROD_DEVTOOLS__ = appConfig.stage !== Stage.LIVE;

const store = createStore(Store);
const app = createApp({
  components: {
    Slider,
    Benefits,
    MapView,
    MapPlace,
    ReviewList,
    SmallNavigation,
    ThemeSwitcher,
    OnlineCourses,
    CourseOverview,
    ContactBar,
    NewsletterAndContactButton,
  },
});

app.use(store);
app.use(Signup);
app.use(AppMessages);

initLogger();

app.mount('#frontpage');
